import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonBaseProps } from '../../ui/buttons';
import { ButtonTransparent } from '../../ui/buttons/ButtonTransparent';

export const CancelButton: React.FC<ButtonBaseProps> = props => {
  const { t } = useTranslation('common');
  return <ButtonTransparent {...props}>{t('cancel')}</ButtonTransparent>;
};
